import { IChecklistTaskRequestItem } from '@features/Checklist/model/types';
import { $api } from '@shared/api';
import { keysToSnakeObject } from '@shared/helpers/camelToSnake';

import {
    getChecklistDataUrl,
    updateChecklistDataUrl,
    deleteChecklistDataUrl,
    switchChecklistItemUrl,
} from './api-routes';

export const checklistApiHandlers = {
    getChecklistData: async ({ signal }: { signal: AbortSignal }, positionGuid: string) =>
        $api(`${getChecklistDataUrl.replace('_guid_', positionGuid)}`, {
            signal,
            validateStatus: (status) =>
                (status >= 200 && status < 300) || status === 403 || status === 400,
        }),
    updateChecklistData: async ({
        positionGuid,
        data,
    }: {
        positionGuid: string;
        data: IChecklistTaskRequestItem[];
    }) => {
        const payload = keysToSnakeObject(data);
        return $api.post(`${updateChecklistDataUrl.replace('_guid_', positionGuid)}`, {
            items: payload,
        });
    },
    deleteChecklist: async ({ positionGuid }: { positionGuid: string }) =>
        $api.post(`${deleteChecklistDataUrl.replace('_guid_', positionGuid)}`),
    switchChecklistItem: async ({
        positionGuid,
        checklistItemId,
    }: {
        positionGuid: string;
        checklistItemId: string;
    }) => {
        const formattedUrl = switchChecklistItemUrl
            .replace('_id_', checklistItemId)
            .replace('_guid_', positionGuid);
        return $api.post(formattedUrl);
    },
};
